import { getAdminT } from "../i18n/getAdminT";
import { getAdminUiLocale } from "../i18n/getAdminUiLocale";
import { getApp } from "firebase/app";
import { getFunctions, httpsCallable } from "firebase/functions";
import { useState } from "react";
import { DeleteEventModal } from "./DeleteEventModal";

type OpenDeleteEventActionParams = {
  key: string;
  accountId: string;
  eventId: string;
  eventName: string;
  onSuccess?: () => void;
};

function DeleteEventActionDialog({
  open,
  closeDialog,
  accountId,
  eventId,
  eventName,
  context,
  onSuccess,
}: {
  open: boolean;
  closeDialog: () => void;
  accountId: string;
  eventId: string;
  eventName: string;
  context: FireCMSContext;
  onSuccess?: () => void;
}) {
  const [loading, setLoading] = useState(false);

  return (
    <DeleteEventModal
      open={open}
      onClose={() => {
        if (!loading) {
          closeDialog();
        }
      }}
      eventName={eventName}
      onConfirm={async (confirmName) => {
        setLoading(true);
        try {
          const functions = getFunctions(getApp());
          const callable = httpsCallable(functions, "deleteEvent");
          await callable({ accountId, eventId, confirmName });
          const t = getAdminT(getAdminUiLocale());
          context.snackbarController.open({
            type: "success",
            message: t("deleteEvent.queued"),
          });
          onSuccess?.();
          closeDialog();
          return true;
        } catch (error: unknown) {
          const t = getAdminT(getAdminUiLocale());
          const message =
            error instanceof Error ? error.message : t("common.unknownError");
          context.snackbarController.open({ type: "error", message });
          console.error(error);
          return false;
        } finally {
          setLoading(false);
        }
      }}
    />
  );
}

export function openDeleteEventAction(
  context: FireCMSContext,
  params: OpenDeleteEventActionParams
): void {
  const { key, accountId, eventId, eventName, onSuccess } = params;
  context.dialogsController.open({
    key,
    Component: ({ open, closeDialog }) => (
      <DeleteEventActionDialog
        open={open}
        closeDialog={closeDialog}
        accountId={accountId}
        eventId={eventId}
        eventName={eventName}
        context={context}
        onSuccess={onSuccess}
      />
    ),
  });
}
